import { VHeaders } from '@/models/pagedlistmodel';

export function getTeamListHeaders(vm: any): VHeaders[] {
  return [
    {
      text: vm.$parent.$t('teams.teamGridHeaders.name') as string,
      align: 'left',
      value: 'name',
      sortable: true,
    },
    {
      text: vm.$parent.$t('teams.teamGridHeaders.action') as string,
      isNotDataProp: true,
      align: 'center',
      sortable: false,
    },
  ];
}

export function getUserTeamListHeaders(vm: any): VHeaders[] {
  return [
    // {
    //   text: vm.$parent.$t('teams.teamGridHeaders.email') as string,
    //   align: 'left',
    //   value: 'userEmail',
    //   sortable: true,
    // },
    {
      text: 'Advisor Name',
      align: 'left',
      value: 'userEmail',
      sortable: true,
    },
    {
      text: 'Shift',
      align: 'left',
      value: 'shiftName',
      sortable: true,
    },
    {
      text: 'Alternate User',
      align: 'left',
      value: 'alternateUserEmail',
      sortable: true,
    },
    {
      text: 'Alternate Phone',
      align: 'left',
      value: 'alternatePhoneNumber',
      sortable: true,
    },
    {
      text: 'Status',
      align: 'left',
      value: 'availabilityStatus',
      sortable: true,
    },
    {
      text: vm.$parent.$t('teams.teamGridHeaders.action') as string,
      isNotDataProp: true,
      align: 'center',
      sortable: false,
    }
  ];
}
